import React from "react";

const SHORTS_LINK = "https://www.youtube.com/shorts/NhwsweLZtPE";
const WEBSITE_LINK = "https://codeorbit.info/";
const VIDEO_ID = "NhwsweLZtPE";
const THUMBNAIL_URL = `https://img.youtube.com/vi/${VIDEO_ID}/hqdefault.jpg`;

const Advertisement = () => {
  const [visible, setVisible] = React.useState(true);

  React.useEffect(() => {
    if (visible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [visible]);

  if (!visible) return null;

  return (
    <div className="fixed left-0 top-0 w-full h-screen z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm animate-fade-in px-2 sm:px-4">
      <div className="relative w-full max-w-[90vw] sm:max-w-md md:max-w-2xl bg-gradient-to-r from-[#2a1054] to-[#000000] rounded-2xl shadow-[0_0_35px_#7B2FF7aa] border border-white/20 p-3 sm:p-6 flex flex-col md:flex-row gap-4 sm:gap-6 items-center backdrop-blur-md">
        {/* Close Button */}
        <button
          onClick={() => setVisible(false)}
          className="absolute -top-3 -right-3 bg-white/80 hover:bg-red-500 hover:text-white text-gray-700 rounded-full w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center text-xl sm:text-2xl font-bold shadow-md transition-all duration-200"
          aria-label="Close advertisement"
        >
          &times;
        </button>

        {/* Thumbnail */}
        <div
          className="relative w-28 h-28 sm:w-40 sm:h-40 md:w-48 md:h-48 rounded-xl overflow-hidden bg-black border border-white/20 shadow-lg cursor-pointer flex-shrink-0"
          onClick={() => window.open(SHORTS_LINK, "_blank", "noopener,noreferrer")}
        >
          <img
            src={THUMBNAIL_URL}
            alt="YouTube Shorts Thumbnail"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 flex items-center justify-center bg-black/30 hover:bg-black/50 transition">
            <svg
              className="w-10 h-10 sm:w-14 sm:h-14 text-white opacity-90 hover:scale-110 transition-transform"
              fill="currentColor"
              viewBox="0 0 48 48"
            >
              <circle cx="24" cy="24" r="24" fill="#000" fillOpacity="0.3" />
              <polygon points="20,16 36,24 20,32" fill="#fff" />
            </svg>
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 w-full text-center md:text-left">

          <h2 className="text-base xs:text-lg sm:text-2xl md:text-3xl font-bold text-white mb-1 sm:mb-2 leading-tight drop-shadow-[0_1px_4px_#0008]">
            CodeOrbit — Final Year Projects Made Easy!
          </h2>
          <p className="text-gray-100 text-xs sm:text-sm md:text-base mb-3 sm:mb-4 max-w-xs sm:max-w-none">
            We provide <span className="font-semibold text-white">Final Year Engineering Projects</span> — ready-made or customized, with full documentation, report, and demo videos.
          </p>

          <div className="flex flex-row gap-2 sm:gap-3 w-full max-w-xs sm:max-w-none">
            <a
              href={WEBSITE_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full sm:w-auto px-4 py-2 sm:px-5 sm:py-2 rounded-lg bg-white text-[#4C52FF] font-semibold hover:bg-gray-200 transition shadow-md text-sm sm:text-base text-center border border-cyan-200/40"
            >
              Visit CodeOrbit
            </a>
            <a
              href={SHORTS_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full sm:w-auto px-4 py-2 sm:px-5 sm:py-2 rounded-lg bg-[#4C52FF] text-white font-semibold hover:bg-[#3b44f2] transition shadow-md border border-cyan-300/40 text-sm sm:text-base text-center"
            >
              Watch Short
            </a>
          </div>
          
          <div className="mt-1 text-[10px] sm:text-xs tracking-wider font-semibold text-cyan-300/90">
            Powered by Pixen
          </div>
        </div>
      </div>
    </div>
  );
};

export default Advertisement;
